import React from 'react';
import styles from './Ebook.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { DownloadRiselio } from '../../components/download-riselio/DownloadRiselio';
import { RiselioDescription } from '../../components/riselio-description/RiselioDescription';

export function Ebook() {
    return (
        <div className="wrapper">
            <section class="hero-section">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-7 pt-5 mb-5 align-self-center">
                            <div class="promo pr-md-3 pr-lg-5">
                                <h1 class="headline mb-5">
                                    VIP &amp; Member <br /> Rp 300.000 <strike>Rp 1.000.000</strike>
                                </h1>
                                <div class="subheadline mb-5" style={{ fontSize: "22px" }}>
                                    Dapatkan masa berlaku VIP member Riselio <b>selamanya</b> + Produk senilai <b>Rp 250.000</b> + E-Book tentang digital marketing dan cara mendapatkan penghasilan lebih dari <b>Rp 2.000.000</b> dari rumah!
                                </div>

                                <div class="subheadline mb-5" style={{ fontSize: "18px" }}>
                                    Masih ragu? Dapatkan <b>15 hari VIP gratis</b>!
                                </div>

                                <div class="cta-holder">
                                    <a class="btn btn-primary p-3" style={{ fontSize: "22px" }} href="https://play.google.com/store/apps/details?id=com.application.riselio">DAFTAR GRATIS SEKARANG</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-5 mb-5 align-self-center">
                            <div class={styles.BookCover}>
                                <img class="img-fluid book-cover" src="./assets/devbook-cover.png" alt="book cover" />
                                <div class={styles.BookBadge}>
                                    Rilis<br></br>Terbaru
					    </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <RiselioDescription />

            <section id="benefits-section" class="benefits-section theme-bg-light-gradient py-5">
                <div class="container py-5">
                    <h2 class="section-heading text-center mb-3">Apa yang akan kamu dapatkan sebagai member VIP?</h2>
                    <div class="section-intro single-col-max mx-auto text-center mb-5">Berikut benefit member VIP Riselio yang akan anda peroleh <b>selamanya cukup hanya sekali bayar saja</b> </div>
                    <div class="row text-center">
                        <div class="item col-12 col-md-6 col-lg-4">
                            <div class="item-inner p-3 p-lg-4">
                                <div class="item-header mb-3">
                                    <div class="item-icon"><i class="fab fa-js-square"></i></div>
                                    <h3 class="item-heading">Harga Khusus</h3>
                                </div>
                                <div class="item-desc">
                                    Member VIP Riselio akan mendapatkan harga termurah sampai dengan 50% dari harga pasaran.
					    </div>
                            </div>
                        </div>
                        <div class="item col-12 col-md-6 col-lg-4">
                            <div class="item-inner p-3 p-lg-4">
                                <div class="item-header mb-3">
                                    <div class="item-icon"><FontAwesomeIcon icon="laptop"></FontAwesomeIcon></div>
                                    <h3 class="item-heading">COD</h3>
                                </div>
                                <div class="item-desc">
                                    Member VIP Riselio akan mendapatkan fasilitas COD ke seluruh Indonesia.
					    </div>
                            </div>
                        </div>
                        <div class="item col-12 col-md-6 col-lg-4">
                            <div class="item-inner p-3 p-lg-4">
                                <div class="item-header mb-3">
                                    <div class="item-icon"><i class="fab fa-rocketchat"></i></div>
                                    <h3 class="item-heading">Ebook Digital Marketing dan Cara Efektif Berjualan</h3>
                                </div>
                                <div class="item-desc">
                                    Member VIP akan mendapatkan Ebook khusus yang diupdate setiap bulannya
					    </div>
                            </div>
                        </div>
                        <div class="item col-12 col-md-6 col-lg-4">
                            <div class="item-inner p-3 p-lg-4">
                                <div class="item-header mb-3">
                                    <div class="item-icon"><i class="fab fa-angular"></i></div>
                                    <h3 class="item-heading">Grup VIP</h3>
                                </div>
                                <div class="item-desc">
                                    Member VIP akan mendapatkan fasilitas khusus dan dipandu di grup Riselio VIP
					    </div>
                            </div>
                        </div>
                        <div class="item col-12 col-md-6 col-lg-4">
                            <div class="item-inner p-3 p-lg-4">
                                <div class="item-header mb-3">
                                    <div class="item-icon"><i class="fas fa-code-branch"></i></div>
                                    <h3 class="item-heading">Produk Riselio</h3>
                                </div>
                                <div class="item-desc">
                                    Saat menjadi member VIP anda akan mendapatkan langsung produk-produk sample senilai <b>Rp 250.000</b>
                                </div>
                            </div>
                        </div>
                        <div class="item col-12 col-md-6 col-lg-4">
                            <div class="item-inner p-3 p-lg-4">
                                <div class="item-header mb-3">
                                    <div class="item-icon"><i class="fas fa-hand-holding-usd"></i></div>
                                    <h3 class="item-heading">Produksi Bersama</h3>
                                </div>
                                <div class="item-desc">
                                    Anda dapat menjadi tangan pertama dengan ikut produksi bersama! Dengan harga yang murah, Anda juga bisa memiliki reseller lagi!
					            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="content-section" class="content-section">
                <div class="container">
                    <div class="single-col-max mx-auto">
                        <h2 class="section-heading text-center mb-5">Apa Saja Isi Ebook VIP?</h2>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="figure-holder mb-5">
                                    <img class="img-fluid" src="./assets/devbook-devices.png" alt="image" />
                                </div>
                            </div>
                            <div class="col-12 col-md-6 mb-5">
                                <div class="key-points mb-4 text-center">
                                    <ul class={styles.ListEbook}>
                                        <li><FontAwesomeIcon icon={faCheckCircle} />Cara memilih sektor target penjualan.</li>
                                        <li><FontAwesomeIcon icon={faCheckCircle} />Cara menggunakan facebook dan instagram ads.</li>
                                        <li><FontAwesomeIcon icon={faCheckCircle} />Tips dan triks cara mendapatkan pelanggan.</li>
                                        <li><FontAwesomeIcon icon={faCheckCircle} />Cara menganalisa ads.</li>

                                    </ul>
                                    <div class="text-center"><a class="btn btn-primary" href="https://t.me/riselio">Beli VIP sekarang juga</a></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="audience" class="audience-section py-5">
                <div class="container">
                    <h2 class="section-heading text-center mb-4">VIP ini untuk siapa</h2>
                    <div class="section-intro single-col-max mx-auto text-center mb-5">
                        Berikut daftar ebook ini cocok untuk
		    </div>
                    <div class={styles.Audience}>
                        <div class={styles.Item}>
                            <div class={styles.ItemIcon}><FontAwesomeIcon icon={faUserCheck} /></div>
                            <div class="media-body">
                                <h4 class={styles.ItemTitle}>Pedagang</h4>
                                <div class="item-desc">Pedagang yang ingin mendapatkan penghasilan tambahan dan belajar digital marketing.</div>
                            </div>
                        </div>
                        <div class={styles.Item}>
                            <div class={styles.ItemIcon}><FontAwesomeIcon icon={faUserCheck} /></div>
                            <div class="media-body">
                                <h4 class={styles.ItemTitle}>Ibu Rumah Tangga</h4>
                                <div class="item-desc">Ibu rumah tangga yang ingin mendapatkan penghasilan tambahan.</div>
                            </div>
                        </div>
                        <div class={styles.Item}>
                            <div class={styles.ItemIcon}><FontAwesomeIcon icon={faUserCheck} /></div>
                            <div class="media-body">
                                <h4 class={styles.ItemTitle}>Mahasiswa</h4>
                                <div class="item-desc">Mahasiswa yang memiliki komunitas di kampus. Dapat menggunakan fitur ajak teman untuk mendapatkan bonus </div>
                            </div>
                        </div>
                        <div class={styles.Item}>
                            <div class={styles.ItemIcon}><FontAwesomeIcon icon={faUserCheck} /></div>
                            <div class="media-body">
                                <h4 class={styles.ItemTitle}>Freelancer</h4>
                                <div class="item-desc">Orang - orang yang memiliki waktu luang untuk membagikan produk di social media.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <DownloadRiselio />
                <br />
                <br />
                <br />
                <br />
            </section>
            {/* <section id="form-section" class="form-section">
                <div class="container">
                    <div class="lead-form-wrapper single-col-max mx-auto theme-bg-light rounded p-5">
                        <h2 class="form-heading text-center">Download sekarang GRATIS</h2>
                        <div class="form-intro text-center mb-3">Daftar Riselio Sekarang juga untuk mendapatkan preview Gratis VIP selama 15 hari.</div>
                        <div class="form-wrapper">
                            <form class="form-inline justify-content-center flex-wrap">
                                <div class="form-group mr-md-2 mb-3 mb-md-0">
                                    <div className="btn-download-apps">
                                        <a href="https://play.google.com/store/apps/details?id=com.application.riselio" target="_blank" rel="noopener noreferrer">
                                            <img className="btn-google-play undragable" alt="Google Play" src="./assets/google-play.png" />
                                        </a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section> */}

        </div>
    );
}